angular.module('tradersyard').directive('requestForm', [
    '$parse',
    'RequestManagerFactory',
    'GuidFactory',
    '$timeout',
    function ($parse, RequestManagerFactory, GuidFactory, $timeout) {
        return {
            scope: true,
            link: function ($scope, $element, $attr) {
                var RequestManager = RequestManagerFactory,
                    Guid = GuidFactory.Generate(),
                    entry,
                    entryId;

                $timeout(function () {
                    entry = $parse($attr.entry)($scope);
                    entryId = $parse($attr.entryId)($scope);

                    RequestManager = RequestManager.Init('me', 'user', $scope);
                });

                $scope.request = function () {
                    RequestManager.Create(entryId, entry, Guid, function (requestData) {
                        if ($attr.after) {
                            $scope.$parent.$evalAsync($attr.after, {
                                $request: requestData,
                            });
                        }
                    });
                };
            },
        };
    },
]);
